var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconETicketbarcode = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { clipPath: "url(#clip0_2083_5956)" },
                React.createElement("path", { d: "M16.875 0H7.125C4.07775 0 2.25 1.8 2.25 4.8V23.1998C2.25 23.7 2.5545 24 3.06225 24C3.57 24 3.8745 23.7 3.8745 23.1998V4.8C3.8745 2.79975 5.09325 1.59975 7.12425 1.59975H16.8743C18.9053 1.59975 20.124 2.79975 20.124 4.8V23.1998C20.124 23.7 20.4285 24 20.9363 24C21.444 24 21.7485 23.7 21.7485 23.1998V4.8C21.7485 1.8 19.92 0 16.8735 0L16.875 0Z", fill: "black" }),
                React.createElement("path", { d: "M5.49976 8.00049H7.12501V9.60024H5.49976V8.00049Z", fill: "black" }),
                React.createElement("path", { d: "M13.6253 12.8003H10.3755V16.0005H13.6253V12.8003Z", fill: "black" }),
                React.createElement("path", { d: "M16.875 19.2002H15.2497V20.8H13.6245V19.2002H11.9992V20.8H10.374V19.2002H8.74875V20.8H7.1235V19.2002H5.49825V17.6005H7.1235V16.0007H5.49825V14.401H7.1235V12.8012H5.49825V11.2015H7.1235V9.6017H8.74875V8.00195H10.374V9.6017H11.9992V8.00195H13.6245V9.6017H15.2497V8.00195H16.875V9.6017H18.5002V11.2015H16.875V12.8012H18.5002V14.401H16.875V16.0007H18.5002V17.6005H16.875V19.2002ZM16.875 19.2002V20.8H18.5002V19.2002H16.875ZM15.2497 11.2H8.7495V17.5997H15.2497V11.2Z", fill: "black" })),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "clip0_2083_5956" },
                    React.createElement("rect", { width: 24, height: 24, fill: "white" }))))),
        alt: 'ETicketbarcode',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconETicketbarcode;
//# sourceMappingURL=index.js.map